/**
 * 與 index.html 內聯腳本搭配：保證 globalThis.process.env.NODE_ENV 與 Vite 模式一致。
 * vite.config define 將識別字 process 替換為 globalThis.process。
 */
if (typeof globalThis.process === "undefined") {
  globalThis.process = { env: {} };
}
globalThis.process.env = globalThis.process.env || {};
globalThis.process.env.NODE_ENV =
  import.meta.env.MODE === "production" ? "production" : "development";
